<div class="sk-container" [ngClass]="{ 'sk-loading': !isLoaded }">
    <loading-screen [displayed]="!isLoaded" [templateType]="'GENERIC'"></loading-screen>
    @if (isLoaded && !isResponseError && eventsBySections.length) {
        <div class="heuristic-container">
            @for (eventsBySection of eventsBySections; track trackById(i, eventsBySection); let i = $index) {
                <accordion data-crlat="accordion" [accordionTitle]="eventsBySection.sectionTitle">
                    <accordion-body data-crlat="eventEntity">
                        @for (eventEntity of eventsBySection.events; track i; let i = $index) {
                            <list-card
                                [item]="eventEntity"
                                [link]="eventURL(eventEntity)"
                                [attr.data-eventid]="eventEntity.id"
                                data-crlat="oddsCard.outrightsTemplate"></list-card>
                        }
                    </accordion-body>
                </accordion>
            }
        </div>
    }
    @if (isLoaded && isResponseError) {
        <request-error (reloadFn)="loadOutrightData()" [loadFailed]="isResponseError"> </request-error>
    }
    @if (isLoaded && !isResponseError && !eventsBySections.length) {
        <no-events></no-events>
    }
</div>
